import util from "../../../util/util";

export const STYLE_SEMIBOLD = {
  fontWeight: 600
};

export const STYLE_LEFT = {
  marginLeft: "2px"
};

export const STYLE_CENTER = {
  textAlign: "center"
};

export const STYLE_RIGHT = {
  textAlign: "right",
  marginRight: "7px"
};

export const STYLE_POINTER = {
  cursor: "pointer"
};

export const STYLE_COLUMN_TITLE_LEFT = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_LEFT
);
export const STYLE_COLUMN_TITLE_LEFT_SELECT = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_LEFT,
  STYLE_POINTER
);
export const STYLE_COLUMN_TITLE_CENTER = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_CENTER
);
export const STYLE_COLUMN_TITLE_CENTER_SELECT = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_CENTER,
  STYLE_POINTER
);
export const STYLE_COLUMN_TITLE_RIGHT = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_RIGHT
);
export const STYLE_COLUMN_TITLE_RIGHT_SELECT = util.concatObject(
  STYLE_SEMIBOLD,
  STYLE_RIGHT,
  STYLE_POINTER
);

export const STYLE_COLUMN_DATA_LEFT_SELECT = util.concatObject(
  STYLE_LEFT,
  STYLE_POINTER
);
export const STYLE_COLUMN_DATA_CENTER_SELECT = util.concatObject(
  STYLE_CENTER,
  STYLE_POINTER
);
export const STYLE_COLUMN_DATA_RIGHT_SELECT = util.concatObject(
  STYLE_RIGHT,
  STYLE_POINTER
);
export const STYLE_COLUMN_DATA_RIGHT_MONEY = util.concatObject(
  STYLE_RIGHT,
  STYLE_SEMIBOLD
);
export const STYLE_COLUMN_DATA_CENTER_MONEY = util.concatObject(
  STYLE_CENTER,
  STYLE_SEMIBOLD
);
